module.exports = __webpack_public_path__ + "img/arbitri.1afd7f0f.png";